/* eslint-disable jsx-a11y/anchor-is-valid */

import React from "react";
import ic_setting_big from "../../assets/images/pictures/icon/ic_settings_big.svg";
import ic_github_big from "../../assets/images/pictures/icon/ic_big_github.svg";
import ic_phone_setting_big from "../../assets/images/pictures/icon/ic_phone-settings_big.svg";
import ic_chat_big from "../../assets/images/pictures/icon/ic_chat_big.svg";
import ic_code_big_circle from "../../assets/images/pictures/icon/ic_code_circle.svg";
import ic_devices_circle from "../../assets/images/pictures/icon/ic_devices_circle.svg";
import ic_doc_circle from "../../assets/images/pictures/icon/ic_doc_circle.svg";
import ic_doc_code_circle from "../../assets/images/pictures/icon/ic_doc-code_circle.svg";
import ic_person_circle from "../../assets/images/pictures/icon/ic_person_circle.svg";
import ic_person_code_circle from "../../assets/images/pictures/icon/ic_person-code_circle.svg";
import ic_setting_circle from "../../assets/images/pictures/icon/ic_settings_circle.svg";
import ic_gopaperless from "../../assets/images/pictures/icon/ic_gopaperless.svg";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import routeVariants from "../../assets/animates/routeVariants";
import Footer from "./../global/Footer";
import NavbarBottom from "./../global/NavbarBottom";

const DevelopersContent = () => {
  const { t } = useTranslation();

  return (
    <motion.div
      variants={routeVariants}
      initial="initial"
      animate="final"
      id="content"
      className="fs-navigation-overlay-content fs-navigation-overlay-left-content fs-navigation__0 no-transform"
    >
      <div id="dev-page">
        <div className="container px-md-0">
          <div className="row mt-50 text-center">
            <div className="col-md-12 mb-50">
              <h2 className="font-weight-bold mx-auto">
                {t(
                  "developers-page.developers-page-content.content-1.big-heading"
                )}
              </h2>
            </div>
          </div>
          <div className="dev-boxes">
            <div className="panel-d panel-d--border">
              <div className="panel-d__body">
                <div className="ic-box">
                  <img
                    src={ic_setting_big}
                    alt="GoPaperless API access token"
                    data-no-retina=""
                  />
                </div>
                <h3 className="py-10">
                  {t(
                    "developers-page.developers-page-content.content-1.small-heading-1"
                  )}
                </h3>
                <h4 className="">
                  {t(
                    "developers-page.developers-page-content.content-1.small-description-1"
                  )}
                </h4>
              </div>
              <div className="panel-d__footer ">
                <a href="javascript:;">
                  {t(
                    "developers-page.developers-page-content.content-1.small-link-1"
                  )}
                </a>
              </div>
            </div>
            <div className="panel-d panel-d--border">
              <div className="panel-d__body">
                <div className="ic-box">
                  <img
                    src={ic_github_big}
                    alt="GoPaperless Github"
                    data-no-retina=""
                  />
                </div>
                <h3 className="py-10">
                  {t(
                    "developers-page.developers-page-content.content-1.small-heading-2"
                  )}
                </h3>
                <h4>
                  {t(
                    "developers-page.developers-page-content.content-1.small-description-2"
                  )}
                </h4>
              </div>
              <div className="panel-d__footer">
                <a href="javascript:;">
                  {t(
                    "developers-page.developers-page-content.content-1.small-link-2"
                  )}
                </a>
              </div>
            </div>
            <div className="panel-d panel-d--border">
              <div className="panel-d__body">
                <div className="ic-box">
                  <img
                    src={ic_phone_setting_big}
                    alt="register mobile-id"
                    data-no-retina=""
                  />
                </div>
                <h3 className="py-10">
                  {t(
                    "developers-page.developers-page-content.content-1.small-heading-3"
                  )}
                </h3>
                <h4 className="">
                  {t(
                    "developers-page.developers-page-content.content-1.small-description-3"
                  )}
                </h4>
              </div>
              <div className="panel-d__footer ">
                <a href="javascript:;">
                  {t(
                    "developers-page.developers-page-content.content-1.small-link-3"
                  )}
                </a>
              </div>
            </div>
            <div className="panel-d panel-d--border">
              <div className="panel-d__body">
                <div className="ic-box">
                  <img
                    src={ic_chat_big}
                    alt="GoPaperless contacts"
                    data-no-retina=""
                  />
                </div>
                <h3 className="py-10">
                  {t(
                    "developers-page.developers-page-content.content-1.small-heading-4"
                  )}
                </h3>
                <h4>
                  {t(
                    "developers-page.developers-page-content.content-1.small-description-4"
                  )}
                </h4>
              </div>
              <div className="panel-d__footer">
                <a href="javascript:;">
                  {t(
                    "developers-page.developers-page-content.content-1.small-link-4"
                  )}
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="container mb-50">
          <div className="row text-center mt-80">
            <div className="col-md-8 col-md-offset-2">
              <img
                className="mb-20"
                src={ic_code_big_circle}
                data-no-retina=""
                alt="GoPaperless APIs"
              />
              <h2 className="mb-25 font-weight-bold">
                {t(
                  "developers-page.developers-page-content.content-2.big-heading"
                )}
              </h2>
              <p className="mb-40">
                {t(
                  "developers-page.developers-page-content.content-2.big-description"
                )}
              </p>
            </div>
          </div>

          <div className="row text-center dev-grid">
            <div className="col-sm-4 col-md-4 col-lg-4">
              <div className="panel-d">
                <div className="panel-d__body">
                  <div className="ic-box">
                    <img
                      src={ic_devices_circle}
                      data-no-retina=""
                      alt="GoPaperless Portal API"
                    />
                  </div>
                  <h3>
                    {t(
                      "developers-page.developers-page-content.content-2.small-heading-1"
                    )}
                  </h3>
                  <h4>
                    {t(
                      "developers-page.developers-page-content.content-2.small-description-1"
                    )}
                  </h4>
                  <ul>
                    <li>
                      <a
                        className="btn-white btn-white--mini"
                        href="/solutions/portal-api"
                      >
                        {t(
                          "developers-page.developers-page-content.content-2.button-learnmore"
                        )}
                      </a>
                    </li>
                    <li>
                      <a
                        className="btn-white btn-white--mini"
                        href="javascript:;"
                      >
                        {t(
                          "developers-page.developers-page-content.content-2.button-documentation"
                        )}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-sm-4 col-md-4 col-lg-4">
              <div className="panel-d">
                <div className="panel-d__body">
                  <div className="ic-box">
                    <img
                      src={ic_doc_circle}
                      data-no-retina=""
                      alt="GoPaperless Gateway API"
                    />
                  </div>
                  <h3>
                    {t(
                      "developers-page.developers-page-content.content-2.small-heading-2"
                    )}
                  </h3>
                  <h4>
                    {t(
                      "developers-page.developers-page-content.content-2.small-description-2"
                    )}
                  </h4>
                  <ul>
                    <li>
                      <a
                        className="btn-white btn-white--mini"
                        href="/solutions/e-signing-api"
                      >
                        {t(
                          "developers-page.developers-page-content.content-2.button-learnmore"
                        )}
                      </a>
                    </li>
                    <li>
                      <a
                        className="btn-white btn-white--mini"
                        href="javascript:;"
                      >
                        {t(
                          "developers-page.developers-page-content.content-2.button-documentation"
                        )}
                      </a>
                    </li>
                    <li>
                      <a
                        className="btn-white btn-white--mini"
                        href="javascript:;"
                      >
                        {t(
                          "developers-page.developers-page-content.content-2.button-code-example"
                        )}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="col-sm-4 col-md-4 col-lg-4">
              <div className="panel-d">
                <div className="panel-d__body">
                  <div className="ic-box">
                    <img
                      src={ic_doc_code_circle}
                      data-no-retina=""
                      alt="GoPaperless e-Signing API"
                    />
                  </div>
                  <h3>
                    {t(
                      "developers-page.developers-page-content.content-2.small-heading-3"
                    )}
                  </h3>
                  <h4>
                    {t(
                      "developers-page.developers-page-content.content-2.small-description-3"
                    )}
                  </h4>
                  <ul>
                    <li>
                      <a
                        className="btn-white btn-white--mini"
                        href="/solutions/e-signing-api"
                      >
                        {t(
                          "developers-page.developers-page-content.content-2.button-learnmore"
                        )}
                      </a>
                    </li>
                    <li>
                      <a
                        className="btn-white btn-white--mini"
                        href="javascript:;"
                      >
                        {t(
                          "developers-page.developers-page-content.content-2.button-documentation"
                        )}
                      </a>
                    </li>
                    <li>
                      <a
                        className="btn-white btn-white--mini"
                        href="javascript:;"
                      >
                        {t(
                          "developers-page.developers-page-content.content-2.button-code-example"
                        )}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="row text-center dev-grid">
            <div className="col-sm-4 col-md-4 col-lg-4">
              <div className="panel-d">
                <div className="panel-d__body">
                  <div className="ic-box">
                    <img
                      src={ic_person_circle}
                      data-no-retina=""
                      alt="GoPaperless e-Identification API"
                    />
                  </div>
                  <h3>
                    {t(
                      "developers-page.developers-page-content.content-2.small-heading-4"
                    )}
                  </h3>
                  <h4>
                    {t(
                      "developers-page.developers-page-content.content-2.small-description-4"
                    )}
                  </h4>
                  <ul>
                    <li>
                      <a
                        className="btn-white btn-white--mini"
                        href="/solutions/e-identification-api"
                      >
                        {t(
                          "developers-page.developers-page-content.content-2.button-learnmore"
                        )}
                      </a>
                    </li>
                    <li>
                      <a
                        className="btn-white btn-white--mini"
                        href="javascript:;"
                      >
                        {t(
                          "developers-page.developers-page-content.content-2.button-documentation"
                        )}
                      </a>
                    </li>
                    <li>
                      <a
                        className="btn-white btn-white--mini"
                        href="javascript:;"
                      >
                        {t(
                          "developers-page.developers-page-content.content-2.button-code-example"
                        )}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-sm-4 col-md-4 col-lg-4">
              <div className="panel-d">
                <div className="panel-d__body">
                  <div className="ic-box">
                    <img
                      src={ic_person_code_circle}
                      data-no-retina=""
                      alt="GoPaperless e-Identification API"
                    />
                  </div>
                  <h3>
                    {t(
                      "developers-page.developers-page-content.content-2.small-heading-5"
                    )}
                  </h3>
                  <h4>
                    {t(
                      "developers-page.developers-page-content.content-2.small-description-5"
                    )}
                  </h4>
                  <ul>
                    <li>
                      <a
                        className="btn-white btn-white--mini"
                        href="/solutions/e-identification-api"
                      >
                        {t(
                          "developers-page.developers-page-content.content-2.button-learnmore"
                        )}
                      </a>
                    </li>
                    <li>
                      <a
                        className="btn-white btn-white--mini"
                        href="javascript:;"
                      >
                        {t(
                          "developers-page.developers-page-content.content-2.button-documentation"
                        )}
                      </a>
                    </li>
                    <li>
                      <a
                        className="btn-white btn-white--mini"
                        href="javascript:;"
                      >
                        {t(
                          "developers-page.developers-page-content.content-2.button-code-example"
                        )}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="col-sm-4 col-md-4 col-lg-4">
              <div className="panel-d">
                <div className="panel-d__body">
                  <div className="ic-box">
                    <img
                      src={ic_setting_circle}
                      data-no-retina=""
                      alt="GoPaperless e-Sealing API"
                    />
                  </div>
                  <h3>
                    {t(
                      "developers-page.developers-page-content.content-2.small-heading-6"
                    )}
                  </h3>
                  <h4>
                    {t(
                      "developers-page.developers-page-content.content-2.small-description-6"
                    )}
                  </h4>
                  <ul>
                    <li>
                      <a
                        className="btn-white btn-white--mini"
                        href="/solutions/e-sealing-api"
                      >
                        {t(
                          "developers-page.developers-page-content.content-2.button-learnmore"
                        )}
                      </a>
                    </li>
                    <li>
                      <a
                        className="btn-white btn-white--mini"
                        href="javascript:;"
                      >
                        {t(
                          "developers-page.developers-page-content.content-2.button-documentation"
                        )}
                      </a>
                    </li>
                    <li>
                      <a
                        className="btn-white btn-white--mini"
                        href="javascript:;"
                      >
                        {t(
                          "developers-page.developers-page-content.content-2.button-code-example"
                        )}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-color">
        <div className="container security-footer">
          <div className="row">
            <div className="col-sm-8 col-sm-offset-2 text-center mbt-40">
              <img
                alt="GoPaperless"
                src={ic_gopaperless}
                data-no-retina=""
                width="64"
                height="64"
              />
              <h2 className="font-weight-bold">
                {t("developers-page.developers-page-content.content-3.heading")}
              </h2>
              <p>
                {t(
                  "developers-page.developers-page-content.content-3.description"
                )}
              </p>
              <a className="btn-secondary" href="/compliance">
                {t(
                  "developers-page.developers-page-content.content-3.button-learnmore"
                )}
              </a>
            </div>
          </div>
        </div>
      </div>
      <Footer />
      <NavbarBottom />
    </motion.div>
  );
};

export default DevelopersContent;
